import {Modal} from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
    .ant-modal {
        max-width: 92vw;
    }

    .ant-modal-content {
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-close {
        top: 12px;
        right: 12px;
        background-color: rgba(255, 255, 255, 0.75);
        border-radius: 50%;
        width: 32px;
        height: 32px;
        line-height: 32px;
    }

    .ant-modal-close-x {
        width: 32px;
        height: 32px;
        line-height: 32px;
    }
`;

export const PopupImage = styled.img`
    width: 100%;
    height: auto;
    max-height: 82vh;
    object-fit: contain;
    display: block;
`;
